export const activityType: Readonly<any> = {
    Success: 0,
    Warning: 1,
    Failure: 2
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/constants/activityType.ts